import Table from 'antd/es/table';
import Anchor from 'antd/es/anchor';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { Plate } from 'components/layout/plate';
import { EXTRA_LARGE_VIEWPORT, MOBILE_VIEWPORT } from 'modules/theme/config';

export const WeatherCalendarContainer = styled(Plate)`
  padding: 12px 0 4px 12px;
  max-width: calc(100vw - 56px);
  box-shadow: none;

  @media (max-width: ${EXTRA_LARGE_VIEWPORT}px) {
    padding: 8px 8px 0 8px;
    border-radius: 16px;
  }

  @media (max-width: ${MOBILE_VIEWPORT}px) {
    padding: 8px 0 0 0;
    border-radius: 8px;
    max-width: none;
  }
`;

export const DailyDealContainer = styled(Plate)`
  padding: 8px 24px;
  margin-top: 24px;
  overflow: auto;

  @media (max-width: ${EXTRA_LARGE_VIEWPORT}px) {
    padding: 8px 12px;
    border-radius: 16px;
    margin-top: 16px;
  }
`;

export const PublicInfoContainer = styled(DailyDealContainer)`
  background-color: ${({ theme }) => theme.colors.primaryWhite};
  color: white;
  padding: 10px 16px;
  p {
    margin-bottom: 0;
  }
`;

export const CustomEventsContainer = styled.div`
  margin-top: 8px;
`

export const CustomEventText = styled.div`
  color: ${({ theme }) => theme.colors.red};
  padding: 4px 24px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
`

export const EventsContainer = styled(DailyDealContainer)`
  background-color: ${({ theme }) => theme.colors.primaryWhite};
  align-items: start;
  color: white;
  display: flex;
  gap: 16px;
  padding: 8px 16px 10px 8px;
  .container-list {
    flex: 1 1 auto;
  }
  h3 {
    font-size: 14px;
    font-weight: 400;
    margin: 0;
    color: white;

    @media (max-width: ${EXTRA_LARGE_VIEWPORT}px) {
      font-size: 12px;
    }
  }
`;

export interface ITeeTimeTableContainer {
  $shrink: boolean;
}

export const TeeTimeTableContainer = styled.div<ITeeTimeTableContainer>`
  margin-top: 24px;
  transition: margin 0.266s ease-out;
  transition-delay: ${({ $shrink }) => ($shrink ? '0.266s' : '0')};
  margin-left: ${({ $shrink }) => ($shrink ? '-434px' : '0')};

  @media (max-width: ${EXTRA_LARGE_VIEWPORT}px) {
    margin-top: 16px;
    margin-left: ${({ $shrink }) => ($shrink ? '-262px' : '0')};
  }
`;

export const TeeTimeTable = styled(Table)`
  .ant-table {
    border-radius: 16px;
    background: transparent;
  }

  .ant-table table {
    background-color: transparent;
    border-radius: 16px 16px 0 0;
    border: 0;

    .ant-table-thead > tr > th {
      background-color: #E7EEF4;
      padding: 16px 12px;
      font-size: 20px;
      line-height: 24px;
      font-weight: 400;
      &:first-child {
        padding-left: 32px;
      }
    }

    .ant-table-tbody > tr:last-child {
      border-radius: 16px;
    }

    .ant-table-tbody > tr > td {
      border-color: #E7EEF4;
      padding: 16px 24px;
      font-size: 20px;
      line-height: 24px;
    }

    .ant-table-tbody > tr.ant-table-row {
      > td:first-child {
        border-left: 4px solid transparent;
        transition: border-left-color linear 0.3s;
        padding-left: 32px;
      }

      &:hover > td:first-child {
        border-left: 4px solid ${({ theme }) => theme.colors.red};
      }

      &.hot {
        background-color: ${({ theme }) => theme.colors.background};

        &:hover td {
          background-color: ${({ theme }) => theme.colors.lightGrey};
        }
      }
    }

    > thead > tr:first-child th:first-child {
      border-top-left-radius: 16px;
    }

    > thead > tr:first-child th:last-child {
      border-top-right-radius: 16px;
    }
  }

  .ant-table table .ant-table-tbody > tr:last-child > td:last-child,
  .ant-table table .ant-table-tbody > tr:last-child > th:last-child {
    border-bottom-right-radius: 16px;
  }

  .ant-table table .ant-table-tbody > tr:last-child > td:first-child,
  .ant-table table .ant-table-tbody > tr:last-child > th:first-child {
    border-bottom-left-radius: 16px;
  }

  .ant-table-sticky-holder {
    background-color: ${({ theme }) => theme.colors.background};
  }

  .ant-table-container {
    border-radius: 16px;
  }

  @media (max-width: ${EXTRA_LARGE_VIEWPORT}px) {
    .ant-table table {
      .ant-table-thead > tr > th {
        font-size: 16px;
        line-height: 20px;
      }

      .ant-table-tbody > tr > td {
        font-size: 16px;
        line-height: 20px;
        padding: 12px 16px;
      }
    }
  }
`;

export const TableHeaderContainer = styled.div``;

export const TableRateHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  .rateHeaderIcon {
    position: relative;
    width: 10px;
    right: -2px;
    svg {
      position: relative;
      top: 2px;
    }
  }
`;

export const TableLink = styled(Link)`
  text-decoration: none;
`;

export const HeaderAnchor = styled(Anchor)`
  background: ${({ theme }) => theme.colors.background};
  overflow: hidden;
  margin-left: -470px;
  padding-left: 470px;

  @media (max-width: ${EXTRA_LARGE_VIEWPORT}px) {
    margin-left: -300px;
    padding-left: 300px;
  }
`;

export const BookingListContainer = styled.div<{ $hasDailyDeal?: boolean }>`
  display: flex;
  flex-direction: column;

  .ant-affix {
    z-index: 2;

    .ant-anchor-wrapper {
      padding-bottom: ${({ $hasDailyDeal }) => Boolean($hasDailyDeal) ? 56 : 16}px;
    }
  }
`;

